export default __webpack_public_path__ + "static/media/538.1d7bc442.png";